export enum ActivityType {
  Presential = 'presential',
  Virtual = 'virtual',
}
